module.exports = __webpack_public_path__ + "img/keplrapprove.2fffaff3.png";